<template>
  <section>
    <MusicPlayer/>
    <div>
      <section>
        <h1 class="loginContainer_title">APITEST</h1>
          <button type="button" id="login-button" class="mt-3 success" @click="login()">Login</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="searchTrue()">products.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getArtistList()">artist_list.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getArtistDetail(5)">artist.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getArtistTunes(5)">artist_products.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getRecommendPrayListSet(2)">playlist_recommend_list.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getRecommendPrayList(4)">playlist_recommend.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="musicPlayerModuleSetPlayList(4)">playlist_recommend_to_customer.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getCustomer()">customer.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="setCostomePlayList()">customer_complete.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="findCustomerPlayList()">playlist_customer.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="appendConstmerPlayList()">playlist_customer_add.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="updateConstmerPlayList()">playlist_customer_rank.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="getFavoriteTunes($store.state.transactionId)">favorite.php</button><br>
          <button type="button" id="login-button" class="mt-3 success" @click="addFavoriteTunes()">favorite_add.php</button><br>
      </section>
      <div>
      {{ data }}
    </div>
    </div>
  </section>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
import PlayListService from '@/components/services/PlayListService.vue'
import ArtistService from '@/components/services/ArtistService.vue'
import FavoriteService from '@/components/services/FavoriteService.vue'
export default {
  name: 'APiTest',
  data () {
    return {
      userName: null,
      password: null,
      data: null
    }
  },
  methods: {
    login () {
      this.logging('methods: login')
      let formData = new URLSearchParams()
      // formData.append('login_id', this.userName)
      // formData.append('login_pass', this.password)
      formData.append('login_id', 'withm')
      formData.append('login_pass', 'videosonic')
      UserService.login(formData, (response) => {
        if (response.success) {
          this.data = response
          this.$store.commit('updateStateTransactionId', response.transactionid)
        }
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * 楽曲検索
     **/
    searchTrue () {
      this.logging('methods: searchTrue')
      let formData = new URLSearchParams()
      formData.append('tag', this.$store.state.tags_select)
      formData.append('scene', this.$store.state.scenes_select)
      formData.append('transactionid', this.$store.state.transactionId)
      PlayListService.searchTrue(formData, (response) => {
        this.logging(response)
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * アーティストを取得
     **/
    getArtistList () {
      this.logging('methods: getArtistList')
      var transactionid = this.$store.state.transactionId
      ArtistService.getArtistList(transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * artistIdを使用してアーティストの詳細を取得
     **/
    getArtistDetail (artistId) {
      this.logging('methods: getArtistDetail()')
      var transactionid = this.$store.state.transactionId
      ArtistService.findArtist(artistId, transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * artistIdを使用してアーティストの楽曲を取得
     **/
    getArtistTunes (artistId) {
      this.logging('methods: getArtistTunes()')
      var transactionid = this.$store.state.transactionId
      ArtistService.findArtistTunes(artistId, transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * artistIdを使用してアーティストの楽曲を取得
     **/
    getRecommendPrayListSet (typeId) {
      this.logging('methods: getArtistTunes()')
      var transactionid = this.$store.state.transactionId
      PlayListService.findRecommendPlayListSet(typeId, transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * artistIdを使用してアーティストの楽曲を取得
     **/
    getRecommendPrayList (playListId) {
      this.logging('methods: getArtistTunes()')
      var transactionid = this.$store.state.transactionId
      PlayListService.findRecommendPlayList(playListId, transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * プレイリストを登録
     **/
    musicPlayerModuleSetPlayList (playlistId) {
      this.logging('methods: searchTrue')
      let formData = new URLSearchParams()
      formData.append('playlist_id', playlistId)
      formData.append('transactionid', this.$store.state.transactionId)
      PlayListService.createPlayList(formData, (response) => {
        this.logging(response)
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * 新郎新婦情報
     **/
    getCustomer () {
      this.logging('methods: getCustomer')
      var transactionid = this.$store.state.transactionId
      UserService.findCustomer(transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    setCostomePlayList () {
      this.logging('methods: setCostomePlayList')
      var transactionid = this.$store.state.transactionId
      UserService.createConstmerPlayList(transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    findCustomerPlayList () {
      this.logging('methods: findCustomerPlayList')
      var transactionid = this.$store.state.transactionId
      UserService.findCustomerPlayList(transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    appendConstmerPlayList () {
      this.logging('methods: appendConstmerPlayList')
      let formData = new URLSearchParams()
      formData.append('product_id', 1)
      formData.append('scene_id', 2)
      formData.append('transactionid', this.$store.state.transactionId)
      UserService.appendConstmerPlayList(formData, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    updateConstmerPlayList () {
      this.logging('methods: updateConstmerPlayList')
      let formData = new URLSearchParams()
      formData.append('transactionid', this.$store.state.transactionId)
      UserService.updateConstmerPlayList(formData, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * お気に入り楽曲を取得
     * @param transactionid
     **/
    getFavoriteTunes (transactionid) {
      this.logging('methods: getFavoriteTunes')
      FavoriteService.findAllFavoriteTune(transactionid, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * お気に入り楽曲を取得
     * @param transactionid
     **/
    addFavoriteTunes () {
      this.logging('methods: addFavoriteTunes')
      let formData = new URLSearchParams()
      formData.append('product_id', 6)
      formData.append('transactionid', this.$store.state.transactionId)
      FavoriteService.addFavoriteTune(formData, (response) => {
        this.data = response
      }, (error) => {
        this.logging(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/apiTest.vue